import type { ReactNode } from 'react';
import { ArrowRight, X } from 'lucide-react';

interface OnboardingAlertBarProps {
  children: ReactNode;
  actionLabel: ReactNode;
  onAction: () => void;
  onDismiss: () => void;
  dismissLabel: string;
}

export default function OnboardingAlertBar({
  children,
  actionLabel,
  onAction,
  onDismiss,
  dismissLabel,
}: OnboardingAlertBarProps) {
  return (
    <div
      className="flex items-center gap-3 px-10 py-2.5 border-b text-[13px] text-foreground shrink-0"
      style={{
        background: 'linear-gradient(90deg, hsl(214 72% 38% / 0.06), hsl(221 83% 53% / 0.04))',
        borderBottomColor: 'hsl(214 72% 38% / 0.15)',
      }}
    >
      <span
        className="w-2 h-2 rounded-full shrink-0"
        style={{ background: 'hsl(160 76% 28%)', boxShadow: '0 0 0 3px hsl(160 76% 28% / 0.2)' }}
      />
      <span>{children}</span>
      <button
        type="button"
        className="ml-auto inline-flex items-center gap-1.5 text-primary font-medium hover:underline"
        onClick={onAction}
      >
        {actionLabel} <ArrowRight className="w-3.5 h-3.5" />
      </button>
      <button
        type="button"
        onClick={onDismiss}
        className="text-muted-foreground inline-flex ml-1"
        title={dismissLabel}
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
